import { render, staticRenderFns } from "./TenderCardActions.vue?vue&type=template&id=4c694785&"
import script from "./TenderCardActions.vue?vue&type=script&lang=js&"
export * from "./TenderCardActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports